import React from "react";

import {} from "../redux/actions";
import { connect } from "react-redux";
import EventControl from "./EventControl";
import EventView from "./EventView";

class Events extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: false
        };
    }

    render() {
        return (
            <React.Fragment>
                {this.props.events.map((e, i) => {
                    return (
                        <React.Fragment key={i}>
                            <EventControl
                                index={i}
                                event={e}
                                parentTrackIndex={this.props.parentTrackIndex}
                                childTrackIndex={this.props.childTrackIndex}
                                dragStart={this.props.dragStart}
                                dragEnd={this.props.dragEnd}
                                dragging={this.props.dragging}
                                dragTimeBlockIndex={
                                    this.props.dragTimeBlockIndex
                                }
                                dragTimeBlockRow={this.props.dragTimeBlockRow}
                                movingEventIndex={this.props.movingEventIndex}
                                onFocus={index => {
                                    this.setState({
                                        selected: index
                                    });
                                }}
                                onBlur={() => {
                                    this.setState({
                                        selected: false
                                    });
                                }}
                            />
                            <EventView
                                index={i}
                                event={e}
                                parentTrackIndex={this.props.parentTrackIndex}
                                childTrackIndex={this.props.childTrackIndex}
                                dragStart={this.props.dragStart}
                                dragEnd={this.props.dragEnd}
                                dragging={this.props.dragging}
                                dragTimeBlockIndex={
                                    this.props.dragTimeBlockIndex
                                }
                                dragTimeBlockRow={this.props.dragTimeBlockRow}
                                movingEventIndex={this.props.movingEventIndex}
                                selected={this.state.selected === i}
                                showChildren={this.props.showChildren}
                            />
                        </React.Fragment>
                    );
                })}
            </React.Fragment>
        );
    }
}

export default connect(
    store => {
        return {};
    },
    {}
)(Events);
